module.exports = __webpack_public_path__ + "20b407d3826ea01221d968919c8d6b8a.svg";